import React from 'react';
import { connect } from "react-redux";
import updateItem from '../../../../API/Provider/PutCountry'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from '../../../../Global/loader'
import { withNamespaces } from 'react-i18next';
import { Col, Form, Row, Button } from 'react-bootstrap';

class UpdateDrzava extends React.Component {
    constructor(props) {
        super(props); 
        this.submit = this.submit.bind(this);
    }

    state={
        loading: false       
    }

    componentDidMount = async () => {
        document.title = this.props.t("Country") + "-" + this.props.t("Create")
 
         await this.setState({
             loading: false            
         })
    }

    handleChange(e){
        this.props.mapState("CHANGE_CODEBOOK_ONE_COUNTRY_DETAILS", e.target)
    }

    submit = async (e) => {        
        this.setState({ loading: true })
        e.preventDefault()        

        let update = await updateItem(
            this.props.oneCountry
        )

        if(update.data.status === 200){ 
            store.addNotification({
                title: this.props.t('Success!'),
                message: "Update was successful",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
            this.props.goBack()
        }
        else{
            store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t(update.data.message),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        
    }

    handleCountryChange(e){  
        this.setState({
            country: e
        })                  
    }
   
    render(){  
        const { t } = this.props
        
        return (
            this.state.loading ?
                <Loader />
            :
            <Form className="form-container">
                <Row> 
                    <Col sm={12} lg={6} xl={4}>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2} md={4} htmlFor="country_name">{t('Name')}</Form.Label>
                            <Col sm="10" md="8">
                                <Form.Control     
                                    id="country_name"                          
                                    type="text"
                                    value={this.props.oneCountry.country_name}
                                    onChange={e => this.handleChange(e)}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2} md={4} htmlFor="country_alpha2_code">{t('Alpha 2')}</Form.Label>
                            <Col sm={10} md={8}>
                                <Form.Control   
                                    id="country_alpha2_code"                          
                                    type="text"
                                    value={this.props.oneCountry.country_alpha2_code}
                                    onChange={e => this.handleChange(e)}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2} md={4} htmlFor="country_alpha3_code" >{t('Alpha 3')}</Form.Label>
                            <Col sm={10} md={8}>
                                <Form.Control      
                                        id="country_alpha3_code"                          
                                        type="text"
                                        value={this.props.oneCountry.country_alpha3_code}
                                        onChange={e => this.handleChange(e)}
                                    />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2} md={4} htmlFor="country_un_code">{t('UN code')}</Form.Label>
                            <Col sm={10} md={8}>
                                <Form.Control
                                    id="country_un_code"
                                    type="text"
                                    value={this.props.oneCountry.country_un_code}
                                    onChange={e => this.handleChange(e)}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2} md={4} htmlFor="fiscalize">{t('Fiscalize')}</Form.Label>
                            <Col sm="10" md="8">
                                <Form.Label className="checbox-form-label" htmlFor="gridCheck2">
                                   <input    
                                        id="fiscalize"                       
                                        type="checkbox"
                                        checked={this.state.fiscalize}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Row className="form-group row">
                            <Col sm={12} className="text-center">                                
                                <Button                                     
                                    className="btnSpremi"                                     
                                    onClick={(e) => this.submit(e)}
                                >
                                    {t('Save')}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                
                <Row className="back-button-container">
                    <Button
                        variant='default'
                        className="btn-default mt-2 mb-2"
                        onClick={() => this.props.goBack()}
                    >
                        <BsBackspaceFill size={30} />  <strong>{t('Back')}</strong>
                    </Button>
                </Row>
            </Form>
        )
    }
}
const mapStateToProps = state => {
    return {
        oneCountry: state.codeBook.oneCountry
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(UpdateDrzava));


